import React from 'react';
import ProposalTableRow from './ProposalTableRow'
import ProposalTableFooter from './ProposalTableFooter'
import {View, StyleSheet, Text } from '@react-pdf/renderer';
import ProposalTableHeader from './ProposalTableHeader'

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 10,
        marginTop: 5,
        // fontWeight:'bold',
        fontFamily: 'Helvetica-Bold',
        textIndent:'5px'
    },
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: 1,
        borderColor: '#000000 ',
        borderRadius:'3px'
    },
});

const ProposalItemsTable = ({invoice}) => (
    (invoice.items.length > 0) ?
    <>
        <Text style={styles.reportTitle}>Itens da proposta comercial</Text>
        <View style={styles.tableContainer}>
            <ProposalTableHeader />
            <ProposalTableRow items={invoice.items} products={invoice.products} />
            <ProposalTableFooter items={invoice.items} />
        </View>
    </>
    : <></>
);

export default ProposalItemsTable